import { render } from "./ScFonts.vue?vue&type=template&id=52e388bd&scoped=true"
import script from "./ScFonts.vue?vue&type=script&lang=js"
export * from "./ScFonts.vue?vue&type=script&lang=js"

import "./ScFonts.vue?vue&type=style&index=0&id=52e388bd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e388bd"]])

export default __exports__